import { Box, Button, CircularProgress, Container, Grid, TextField, Typography } from "@mui/material"
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"
import { decryptData, encryptData } from "../Utilities/crypto";
import { useFormik } from "formik"
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { AuthOtpLogin } from "../ReduxStore/authSlice";
import showToast from "../Utilities/showToast";
import { NonAuthAxios } from "../Utilities/CommonAxios";


const VerifyOtp = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params = useParams()
    const mobile = decryptData(params.mobile);
    const otpverify = decryptData(params.otp);
    const otpLength = 6;
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [loading, setLoading] = useState(false);
    const [active, setActive] = useState(true);
    const [resendTimer, setResendTimer] = useState(30)

    const inputsRef = useRef([]);

    const otpFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            otp: ""
        }, validationSchema: Yup.object({
            otp: Yup.string()
                .required("Enter the otp")
                .length(otpLength, `otp must be ${otpLength} digits`)
        }),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            const { payload: response } = await dispatch(AuthOtpLogin({
                ...values, mobile
            }))
            setLoading(false)
            if (response.status) {
                showToast('success', response.message)
                navigate('/')
            } else {
                showToast('error', response.message)
            }
        }
    });

    const handleChange = (e, index) => {
        const value = e.target.value.replace(/\D/, "");
        if (!value) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        otpFormik.setFieldValue("otp", newOtp.join("")); // Use newOtp, not otp

        if (index < otpLength - 1) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            if (otp[index] === "" && index > 0) {
                inputsRef.current[index - 1]?.focus();
            } else {
                const newOtp = [...otp];
                newOtp[index] = "";
                setOtp(newOtp);
                otpFormik.setFieldValue("otp", newOtp.join(""));
            }
        }
    };


    useEffect(() => {
        let timer;

        if (active && resendTimer > 0) {
            timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
        } else if (resendTimer === 0) {
            setActive(false);
        }

        return () => clearTimeout(timer);
    }, [active, resendTimer]);


    const handleResend = async (e) => {
        e.preventDefault();
        if (resendTimer === 0) { setActive(true); setResendTimer(30); }
        if (active === false && resendTimer === 0) {

            const apiResponse = await NonAuthAxios({
                url: '/otp',
                method: 'post',
                payload: {
                    mobile: mobile
                }
            })

            if (apiResponse.status) {
                showToast('success', 'otp send to mobile number')
                navigate(`/verify-otp/${encryptData(mobile)}/${encryptData(apiResponse?.data)}`);
            } else {
                showToast('error', apiResponse.message)
            }
        }
    }



    return (
        <>
            <Grid
                container
                sx={{
                    minHeight: "100vh",
                    width: '450px',
                    margin: '20px auto',
                }}
                alignItems="center"
                justifyContent="center"
            >
                <Container>
                    <Grid container spacing={2} justifyContent="center">
                        <form onSubmit={otpFormik.handleSubmit}>
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Box
                                    sx={{
                                        padding: "17px 25px",
                                        borderRadius: "20px",
                                        border: "1px solid #e5e5e5",
                                        backgroundColor: "#fff",
                                        textAlign: "center",
                                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                    }}
                                >

                                    <Typography sx={{
                                        fontFamily: "Segoe UI",
                                        fontSize: "24px",
                                        fontWeight: "normal",
                                        fontStretch: "normal",
                                        fontStyle: "normal",
                                        lineHeight: "normal",
                                        letterSpacing: "normal",
                                        textAlign: "center",
                                        color: "#1d1d1d",
                                    }}>
                                        Verify OTP
                                    </Typography>
                                    <Typography sx={{
                                        fontFamily: "Segoe UI",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        textAlign: "center",
                                        color: "#717182",
                                        marginBottom: '20px',
                                    }}>We've sent a 6-digit OTP to {mobile} - {otpverify}</Typography>

                                    <Box display="flex" gap={1} sx={{ justifyContent: 'space-around', }}>
                                        {otp.map((digit, index) => (
                                            <TextField

                                                key={index}
                                                variant="outlined"
                                                value={digit}
                                                inputProps={{
                                                    maxLength: 1,
                                                    style: {
                                                        textAlign: "center",
                                                        padding: "12px 0",
                                                        fontSize: "16px",
                                                        width: "40px",
                                                        height: "15px",
                                                        background: '#f3f3f5',
                                                        color: '#717182',

                                                    },
                                                }}
                                                onChange={(e) => handleChange(e, index)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                inputRef={(el) => (inputsRef.current[index] = el)}
                                            />
                                        ))}
                                    </Box>
                                    {otpFormik.touched.otp && otpFormik.errors.otp && (
                                        <div style={{ color: "red", marginTop: "8px" }}>{otpFormik.errors.otp}</div>
                                    )}
                                    <Button type="submit" variant="contained" sx={{
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.08)",
                                        backgroundColor: "#ff5714",
                                        fontFamily: "Segoe UI",
                                        fontSize: "15px",
                                        fontWeight: "500",
                                        fontStretch: "normal",
                                        fontStyle: "normal",
                                        lineHeight: "normal",
                                        letterSpacing: "normal",
                                        textAlign: "left",
                                        color: "#fff",
                                        textTransform: "none",
                                        width: '100%',
                                        padding: '10px 16px',
                                        marginTop: '20px',
                                        marginBottom: '10px',
                                        "&:hover": {
                                            backgroundColor: "#e64e12",
                                            boxShadow: "0 6px 120px 0 rgba(0, 0, 0, 0.12)",
                                        },
                                    }}> {loading ? (
                                        <CircularProgress size={20} color="inherit" />
                                    ) : (
                                        "Verify & Continue"
                                    )} </Button>


                                    <Link to='#' onClick={handleResend} style={{
                                        fontFamily: "Segoe UI",
                                        fontSize: "13px",
                                        fontWeight: "normal",
                                        fontStretch: "normal",
                                        fontStyle: "normal",
                                        lineHeight: "normal",
                                        letterSpacing: "normal",
                                        textAlign: "left",
                                        color: "#717182",
                                        textDecoration: 'unset',
                                    }}>
                                        Didn't receive OTP?  <span style={{ color: active ? "#e64e12" : "#e7000b", fontWeight: "500", marginBottom: '20px', }}>
                                            {active ? `Resend in ${resendTimer}s` : `Resend otp`}
                                        </span>
                                    </Link>
                                </Box>

                            </Grid>
                        </form>
                    </Grid>
                </Container >

            </Grid >
        </>
    )
}
export default VerifyOtp